export default __webpack_public_path__ + "static/media/announcement-highlight-summary-outer.fd0ebf8d.svg";